import { render, staticRenderFns } from "./chart-verticalbar-reporttotalsomescreated.vue?vue&type=template&id=b1477df8&"
import script from "./chart-verticalbar-reporttotalsomescreated.vue?vue&type=script&lang=js&"
export * from "./chart-verticalbar-reporttotalsomescreated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports